import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'

const settings = { dots: true, slidesToShow: 1 }

const Sample = ({ task }) => {
  const classes = classnames(
    "samples-section__preview",
    `samples-section__preview--${task.id}`
  )

  return (
    <div>
      <Link className={classes} to={`/examples/${task.id}`}>
        <div className="samples-section__play f--upper f--l f--bold">
          { I18n.t('landing.try') }
        </div>
      </Link>
      <div className="f--l f--text mt-gutter-s">
        { task.name }
      </div>
    </div>
  )
}

const Samples = ({ examples }) => {
  const examplesSeclection = examples.slice(0, 2);

  return (
    <section className="samples-section" id="samples">
      <h1 className="f--purple plate-heading plate-heading--left">
        { I18n.t('landing.examples') }
      </h1>
      <p className="f--l f--text mt-gutter-m mb-2">
        { I18n.t('landing.examples_desc') }
      </p>
      <div className="grid grid--xl-2">
        { _.map(examplesSeclection, (task) => <Sample key={task.id} task={task} />) }
      </div>
    </section>
  )
}

export default Samples
